import { Injectable } from "@angular/core";
import { Router, NavigationEnd, Event } from "@angular/router";

@Injectable({ providedIn: "root" })
export class NavigationService
{
	private history: string[] = [];
	private router: Router;

	public constructor(router: Router)
	{
		this.router = router;

		this.router.events.subscribe((event: Event) =>
		{
			if (event instanceof NavigationEnd)
			{
				this.history.push(event.urlAfterRedirects);
			}
		});
	}

	public goToPreviousPage(defaultRoute: string, state?: any): void
	{
		this.history.pop();
		if (this.history.length > 0)
		{
			const lastUrl: string = this.history.pop();
			this.router.navigateByUrl(lastUrl, { state: state});
		}
		else
		{
			if (defaultRoute)
			{
				this.router.navigateByUrl(defaultRoute, { state: state});
			}
			else
			{
				this.router.navigateByUrl("/", { state: state});
			}
		}
	}
}
